// ESM-Huelle um lib/scripts/CLS_CXmlHandler.js (Phase 4, Welle 1c) -
// XML-Layout-Parser (LYT_*.xml -> Objektbaum). Prototype-Stil bleibt vorerst.
//******************************************************************************
// CXmlHandler
//******************************************************************************
// Description:
//      Provides methods to handle XML objects.
// Parameters:
//      filename - The file name of the XML file to load.
//******************************************************************************

// *** Constructor ***
function CXmlHandler (fileName)
{
    if (fileName)
    {
        this.rootElement = document.implementation.createDocument ("", "", null);
        this.rootElement.async = false;
		var fh = new CFileHandler(fileName);
        //this.rootElement.load (fileName);
		fh.open();
		var str = fh.readAll();
		this.parseFromString(str);
    }
}
//------------------------------------------------------------------------------
// ***

// *** Class variables ***
CXmlHandler.prototype.rootElement = null;
// ***

// *** Class methods ***

//------------------------------------------------------------------------------
CXmlHandler.prototype.parseFromString = function  (string)
{
    var parser = new DOMParser();
    this.rootElement = parser.parseFromString (string, "text/xml");
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Loads an element from an unambiguous XML path.
// Parameters:
//      path - the path from where to load the element, seperated by dots
//             e.g.(root.node1.node2.node3)
// Returns:
//      element - on success
//      null - on failure
//------------------------------------------------------------------------------
CXmlHandler.prototype.getElement = function  (path)
{
    if (path == "")
        return this.rootElement.firstChild;

    var pathArr = path.split(".");

    if (pathArr < 1) return null;

    var elem = this.rootElement.firstChild;
    var childElem, oldElem, success = false;
    
    while (elem)
    {
        if (elem.nodeName == pathArr[0])
        {
            pathArr.shift ();
            
            if (pathArr.length < 1)
            {
                success = true;
                break;
            }
            
            elem = elem.firstChild;
        }
        else
        {
            elem = elem.nextSibling;
        }
    }

    if (!elem || !success) return null;

    return elem;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Loads a value from an unambiguous XML path.
// Parameters:
//      path - the path from where to load the value, seperated by dots
//             e.g.(root.node1.node2.node3)
// Returns:
//      value - on success
//      null - on failure
//------------------------------------------------------------------------------
CXmlHandler.prototype.getValue = function (path)
{
    var elem = this.getElement (path);

    if (!elem) return null;
    
    var value = elem.firstChild.nodeValue;
    
    return value;
}
//------------------------------------------------------------------------------

CXmlHandler.prototype.getValues = function (path)
{
    var pathArr = path.split(".");
    if (pathArr < 1) return null;
    
    var elem = this.getElement (path);
    var name = pathArr[pathArr.length - 1];
    var result = new Array ();
    
    while (elem)
    {
        if (elem.nodeName == name)
            result.push (elem.textContent);
 
        elem = elem.nextSibling;
    }
    
    return result;
}

//------------------------------------------------------------------------------ ???
// Description:
//      Returns the number of the given node in the given path.
// Parameters:
//      path - the path of where to count, seperated by dots
//             e.g.(root.node1.node2.node3)
//      node - count this node
// Returns:
//      count - on success
//      null - on failure
//------------------------------------------------------------------------------
CXmlHandler.prototype.countSiblings = function (path)
{
    var elem = this.getElement (path);
    
    if (!elem) return null;
    
    var nodeName = elem.nodeName;
    var count = 0;
    
    while (elem)
    {
        if (elem.nodeName == nodeName)
            count++;
            
        elem = elem.nextSibling;
    }

    return count;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
CXmlHandler.prototype.findElementByIndex = function (path, index)
{
    var elem = this.getElement (path);

    if (!elem) return null;

    var nodeName = elem.nodeName;
    var n = 0, success = false;

    while (elem)
    {
        if (elem.nodeName == nodeName && n == index)
        {
            success = true;
            break;
        }
        
        if (elem.nodeName == nodeName)
            n++;
                        
        elem = elem.nextSibling;
    }

    if (!elem || !success)
        return null;
        
    return elem;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
CXmlHandler.prototype.applyAttributes = function (path, element)
{
    var xelem;

    if (!path) path = "attributes";
    else path += ".attributes";
        
    xelem = this.getElement (path);
    
    if (!xelem) return element;
    
    var attr = xelem.getElementsByTagName ("attribute");

    for (var i = 0; i < attr.length; i++)
    {
        var name = attr[i].attributes["name"].nodeValue;
        var val = attr[i].firstChild.nodeValue;
        
        element.setAttribute (name, val);
    }
    
    return element;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
CXmlHandler.prototype.convert2Object = function (path)
{
    var element = this.getElement (path);
    if (!element) return null;

    var object = this.getObject (element);

    return object[element.nodeName];
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
CXmlHandler.prototype.getObject = function (element, nextSibling)
{
    var object = new Object ();
    
    while (element)
    {
        if (element.childNodes.length > 1)
            object[element.nodeName] = this.getObject (element.firstChild);
        else if (element.childNodes.length > 0 && element.nodeName != "length")
            object[element.nodeName] = element.textContent;

        if (typeof nextSibling == "undefined" || nextSibling)
            element = element.nextSibling;
        else
            break;
    }
    
    return object;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------ ???
// Description:
//      Applies styles from an XML source to the given element.
// Parameters:
//      element - the element to apply the styles to
//      path - the path from where to load the style settings, seperated by dots
//             e.g.(root.node1.node2.node3)
// Returns:
//      element - on success (with new styles applied)
//      element - on failure (with no new styles applied)
//------------------------------------------------------------------------------
CXmlHandler.prototype.applyStyles = function (path, element)
{
    var xelem;

    if (!path) path = "styles";
    else path += ".styles";
        
    xelem = this.getElement (path);
    
    if (!xelem) return element;
    
    var styles = xelem.getElementsByTagName ("style");

    for (var i = 0; i < styles.length; i++)
    {
        var name = styles[i].attributes["property"].nodeValue;
        var val = styles[i].firstChild.nodeValue;

        switch (name)
        {
            case "position":
                element.style.position = val;
                break;
            case "width":
                element.style.width = val;
                break;
            case "height":
                element.style.height = val;
                break;
            case "top":
                element.style.top = val;
                break;
            case "bottom":
                element.style.bottom = val;
                break;
            case "left":
                element.style.left = val;
                break;
            case "right":
                element.style.right = val;
                break;
            case "border-width":
                element.style.borderWidth = val;
                break;
            case "border-style":
                element.style.borderStyle = val;
                break;
            case "borderRadius":
                element.style.borderRadius = val;
                break;
            case "opacity":
                element.style.opacity = val;
                break;
            case "background-color":
                element.style.backgroundColor = val;
                break;
            case "border-color":
                element.style.borderColor = val;
                break;
            case "margin":
                element.style.margin = val;
                break;
            case "margin-top":
                element.style.marginTop = val;
                break;
            case "margin-bottom":
                element.style.marginBottom = val;
                break;
            case "margin-left":
                element.style.marginLeft = val;
                break;
            case "margin-right":
                element.style.marginRight = val;
                break;
            case "overflow":
                element.style.overflow = val;
                break;
            case "padding":
                element.style.padding = val;
                break;
            case "padding-top":
                element.style.paddingTop = val;
                break;
            case "padding-right":
                element.style.paddingRight = val;
                break;
            case "padding-bottom":
                element.style.paddingBottom = val;
                break;
            case "padding-left":
                element.style.paddingLeft = val;
                break;
            case "vertical-align":
                element.style.verticalAlign = val;
                break;
            case "text-align":
                element.style.textAlign = val;
                break;
            case "display":
                element.style.display = val;
                break;
            case "cursor":
                element.style.cursor = val;
                break;
            case "-moz-user-select":
                element.style.MozUserSelect = val;
                break;
            case "font-weight":
                element.style.fontWeight = val;
                break;
            case "font-family":
                element.style.fontFamily = val;
                break;
            case "line-height":
                element.style.lineHeight = val;
                break;
            case "margin-top":
                element.style.marginTop = val;
                break;
            case "margin-bottom":
                element.style.marginBottom = val;
                break;
            case "empty-cells":
                element.style.emptyCells = val;
                break;
            case "font-size":
                element.style.fontSize = val;
                break;
            case "color":
                element.style.color = val;
                break;
            case "text-decoration":
                element.style.textDecoration = val;
                break;
            case "background-image":
                element.style.backgroundImage = val;
                break;
            case "background-position":
                element.style.backgroundPosition = val;
                break;
        }
    }
    
    return element;
}
//------------------------------------------------------------------------------
// ***

//******************************************************************************
export { CXmlHandler };
